
export class FiltrosLiquidaciones{

    IdProv : string = '';
    IdAdq :string ='';
    Estado : string = 'P';
    FechaIni : string = '';
    FechaFin : string = '';
    Moneda : number = 0;
}